export default __webpack_public_path__ + "static/media/xml_icon.87b9d006.png";